module.exports = __webpack_public_path__ + "img/21.cdb51db7.jpg";